import { MapPinIcon } from "@heroicons/react/24/outline";
import {
  IconCircle1,
  IconHomeCheck,
  IconNumber1,
  IconNumber2,
  IconNumber3,
} from "@tabler/icons-react";
import ButtonPrime from "@/components/navigation/ButtonPrime";
import React from "react";
import ContactModal from "./ModalBeartungsTermin";

export default function StepsVerkaufen() {
  return (
    <div className="flex md:flex-row flex-col gap-10">
      <div>
        <img
          className="h-full rounded-lg md:rounded-lg object-cover md:max-w-[30rem] max-h-[18rem] md:max-h-none flex-1"
          src="/Fotos/bewertung_steps.jpg"
          alt="Leon Jakobs Immobilienbewertung"
        />
      </div>
      <div className="w-full max-w-[40rem] mx-auto">
        <div className="group relative flex gap-x-5">
          <div className="relative group-last:after:hidden after:absolute after:top-8 after:bottom-2 after:start-3 after:w-px after:-translate-x-[0.5px] after:bg-gray-200">
            <div className="relative z-10 size-6 flex justify-center items-center">
              <IconNumber1 className="p-1  rounded-full border border-gray-300" />
            </div>
          </div>

          <div className="grow pb-8 group-last:pb-0">
            <p className="font-medium text-xl text-gray-800">
              Immobilie beschreiben
            </p>

            <p className="mt-1 text-lg text-gray-600">
            Tragen Sie einfach die wichtigsten Eckdaten in unser Formular ein.
            </p>
          </div>
        </div>

        <div className="group relative flex gap-x-5">
          <div className="relative group-last:after:hidden after:absolute after:top-8 after:bottom-2 after:start-3 after:w-px after:-translate-x-[0.5px] after:bg-gray-200">
            <div className="relative z-10 size-6 flex justify-center items-center">
              <IconNumber2 className="p-1  rounded-full border border-gray-300" />
            </div>
          </div>

          <div className="grow pb-8 group-last:pb-0">
            <p className="font-medium text-xl text-gray-800">
              Vor-Ort-Termin vereinbaren{" "}
            </p>

            <p className="mt-1 text-lg text-gray-600">
            Wir prüfen Ihre Angaben und kontaktieren Sie, um einen Termin vor Ort zu vereinbaren.
            </p>
          </div>
        </div>

        <div className="group relative flex gap-x-5">
          <div className="relative group-last:after:hidden after:absolute after:top-8 after:bottom-2 after:start-3 after:w-px after:-translate-x-[0.5px] after:bg-gray-200">
            <div className="relative z-10 size-6 flex justify-center items-center">
              <IconNumber3 className="p-1  rounded-full border border-gray-300" />
            </div>
          </div>

          <div className="grow pb-8 group-last:pb-0">
            <p className="font-medium text-xl text-gray-800">
            Bewertung erhalten
            </p>

            <p className="mt-1 text-lg text-gray-600">
            Sie erhalten eine verständliche Einschätzung des Marktwerts – als sichere Grundlage für Ihre nächsten Schritte.            </p>
          </div>
        </div>

        <ContactModal
          trigger={
            <ButtonPrime
              url="/bewerten/formular/online-bewertung"
              text={`Kostenlose Immobilienbewertung`}
              icon={<IconHomeCheck  />}
              data-umami-event="bewertungsseite_steps_bewerten"

            />
          }
        />

        <div className="flex md:gap-3 gap-1 items-center relative"></div>
      </div>
    </div>
  );
}
